import { required } from 'vee-validate/dist/rules'
import { extend, ValidationProvider, ValidationObserver, setInteractionMode } from "vee-validate"
import { mapGetters } from 'vuex';
setInteractionMode("eager")
extend("required", {
    ...required,
    message: "{_field_} no puede estar vacio",
});
const suggestion = {
    components: { ValidationObserver, ValidationProvider },
    data: () => ({
        showForm: false,
        valid: false,
        loading: false,
        loadingTbl: false,
        suggestionTypes: ['Feedback', 'Reconocimiento'],
        suggestion: {
            name: '', // Asumiendo que el nombre del usuario está en el store
            type: '',
            message: '',
            campaigns: ''
        },
        headers: [
            { text: "Sugerencia", value: "sugerencia", align: 'start', sortable: false, width: '400px' },
            { text: "Tipo de sugerencia", value: "tipo_sugerencia", align: 'start', sortable: false },
            { text: "Nombre del cliente", value: "Nombre", align: 'start', sortable: false },
            { text: "Fecha y hora", value: "fecha", align: 'start', sortable: false },
            { text: "Campañas vinculadas", value: "NombreCampanas", align: 'start', sortable: false },
        ],
        suggestions: [],
    }),
    mounted() {
        this.suggestion.name = this.$store.state.username;
        this.fetchSuggestion();
    },
    computed: {
        ...mapGetters(['getCampanas', 'getCampanasAsignadas']),
        filteredCampanas() {
            return this.getCampanas.filter(campana =>
                this.getCampanasAsignadas.includes(campana.Id.toString())
            );
        },
        creatorId() {
            return this.$store.state.id;
        },
        Rol() {
            return this.$store.state.rol;
        },
    },
    methods: {
        openForm() {
            this.resetForm();
            this.showForm = true;
        },
        cancelForm() {
            this.resetForm();
            this.showForm = false;
            this.$refs.datos.reset();
        },
        resetForm() {
            this.suggestion = {
                name: this.$store.state.username, // Restablecer el nombre del usuario desde el store
                type: '',
                message: ''
            };
        },
        async submitSuggestion() {
            this.loading = true;
            const payload = {
                userId: this.$store.state.id, // Enviar el ID del usuario en lugar del nombre
                type: this.suggestion.type,
                message: this.suggestion.message,
                campaigns: this.suggestion.campaigns
            };
            try {
                const response = await this.$axios.post('newSuggestion', payload);
                this.cancelForm();
                this.$toast.success('Sugerencia enviada con éxito');
            } catch (error) {
                //console.error('Error al enviar la sugerencia:', error);
                this.$toast.error('Hubo un error al enviar la sugerencia');
            } finally {
                this.loading = false;
            }

        },
        async fetchSuggestion() {
            this.loadingTbl = true;
            try {
                const response = await this.$axios.get('getSuggestion');
                this.suggestions = response.data.suggestion;
            } catch (error) {
                this.$toast.error('Problemas en obtener los datos');
            } finally {
                this.loadingTbl = false;
            }
        }
    }
}
export default suggestion